import { BaseDTO } from "./basedto";
import { PartInfoInProposal } from "./partinfoinproposal";
import { PackageInfo } from "./packageinfo";
import { Proposal } from "./proposal";
import { ProposalEstimate } from "./proposal-estimate";

export class CreateProposalDTO extends BaseDTO {
    DefaultProposal: Proposal;
    OverriddenProposal : Proposal;
    GapOverrideResponse: number;
    EstimateProposal: ProposalEstimate[];
    
    constructor(){
        super();
        this.DefaultProposal = new Proposal();
        this.OverriddenProposal = new Proposal();
        this.EstimateProposal = [];
    }
}

